import * as React from "react";
import { singleton } from "logic/singleton";
export const SAVE_COPY = {
  save: { isShown: false },
  saveAs: { isShown: true },
  share: { isShown: false },
  actionsDropdown: { isShown: false }
};
export const BLANK = {
  save: { isShown: false },
  saveAs: { isShown: false },
  share: { isShown: false },
  actionsDropdown: { isShown: false }
};
export const DEFAULT_STATE = {
  sidebar: { isShown: true },
  viewActions: {
    save: { isShown: true },
    saveAs: { isShown: true },
    share: { isShown: true },
    actionsDropdown: { isShown: true }
  },
  synchronizeUrl: true
};
const SearchPageLayoutContext = React.createContext(DEFAULT_STATE);
export default singleton("contexts.SearchPageLayout", () => SearchPageLayoutContext);
